import React from 'react';
import styled from 'styled-components';

export default function ItemWithImg({price, name, imgUrl, options, text}) {
  return (
    <Container>
    <div className='img-holder'>
            <img loading='lazy' src={imgUrl} alt={name} />
        </div>
        <h4>{name}</h4>
        {options && <span>{text}</span>}
        <p>{price}<span>rsd</span></p>
    </Container>
  )
}

const Container = styled.div`
    color: #fff;
    max-width: 194px;
    text-align: center;
    margin: 3rem;
    max-width: 300px;
    border-bottom: 1px dashed #fff;
    margin-left: auto;
    margin-right: auto;

    div.img-holder{
        padding-bottom: 1rem;

        img{
            width: 100%;
        }
    }

    h4{
        font-size: 1.3rem;
    }

    span{
        font-size: 0.7rem;
    }

    p{
        padding-top: .1rem;
        font-size: 1.8rem;
        font-family: "Roboto", sans-serif;

        span{
            font-family: "Epilogue", sans-serif;
            font-size: 0.8rem;
        }
    }
`;
